import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";

import { OutboundDeliveriesQuery } from "../../../graphql/deliveryService/queries/outboundDeliveries";

interface OutboundDeliveriesQueryProps {
  dataAction: (data: any) => void;
  errorAction?: () => void;
}

const useOutboundDeliveriesQuery = (props: OutboundDeliveriesQueryProps) => {
  const { dataAction, errorAction } = props;

  const query = useLazyQuery(OutboundDeliveriesQuery, {
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: "network-only",
  });

  const { data, error } = query[1];

  const outboundDeliveriesPagedFragment = data?.outboundDeliveries;

  useEffect(() => {
    if (!error) return;
    if (errorAction) {
      errorAction();
    }
  }, [error, errorAction]);

  useEffect(() => {
    if (!data || !outboundDeliveriesPagedFragment) return;
    dataAction(outboundDeliveriesPagedFragment);
  }, [data, dataAction, outboundDeliveriesPagedFragment]);

  return query;
};

export default useOutboundDeliveriesQuery;
